module.exports = __webpack_public_path__ + "img/id.581aa159.svg";